import styled from 'styled-components';

// Holds the left and the right
export const MainContainer = styled.main`
  width: 100%;
  min-height: 100vh;
  display: flex;
  /* border: 2px solid red; */
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
// For the left side - this wrap to the top on tablet
export const LeftUserProfile = styled.aside`
  width: 25%;
  /* padding-top: ${({ theme }) => theme.spacing.m}; */
  padding-inline: ${({ theme }) => theme.spacing.m};
  /* border: 5px solid orange; */
  background-color: ${({ theme }) => theme.colors.grey6};
  /* border: 3px solid orange; */
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: ${({ theme }) => theme.spacing.s};
  }
`;
// For the right side - goes under the left for tablet
export const RightUserProfile = styled.section`
  width: 70%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.white};
  /* border: 3px solid green; */
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: ${({ theme }) => theme.spacing.xs};
  }
`;
export const LinksForUserProfile = styled.div`
  /* border: 1px solid blue; */
  /* padding-top: ${({ theme }) => theme.spacing.xs}; */
  p {
    display: flex;
    gap: ${({ theme }) => theme.spacing.xs};
    align-items: center;
    /* border: 1px solid green; */
    margin-top: ${({ theme }) => theme.spacing.m};
    color: ${({ theme }) => theme.colors.grey1};
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 0.05rem;
  }
  p:hover {
    color: ${({ theme }) => theme.colors.orange2};
  }

  a {
    display: flex;
    flex-direction: column;
    /* border: 2px solid red; */
    font-size: 0.9rem;
    font-weight: 600;
    padding: 0.2rem;
    letter-spacing: 0.1rem;
    text-decoration: none;
    text-transform: capitalize;
    /* transition: color 0.3s ease-in-out; */
    margin-top: ${({ theme }) => theme.spacing.s};
  }

  a:hover {
    color: ${({ theme }) => theme.colors.orange2};
  }
  .courseHover.selected {
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.yellow2} 60%,
      ${({ theme }) => theme.colors.orange2} 100%
    );
    border-radius: 12px;
    color: #222 !important;
    font-weight: bold;
    box-shadow: 0 4px 16px 0 rgba(255, 224, 102, 0.18) 0 0 0 2px #ffe066;
    transform: scale(1.06);
    transition:
      background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      color 0.25s cubic-bezier(0.4, 0, 0.2, 1),
      box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      transform 0.18s cubic-bezier(0.4, 0, 0.2, 1);
    padding-left: 0.5rem;
  }
  @media screen and (max-width: 768px) {
    .links {
      /* border: 2px solid yellow; */
      overflow-y: scroll;
      display: flex;
      padding-left: 0.5rem;
      gap: ${({ theme }) => theme.spacing.s};
    }
    .courseHover.selected {
      padding-left: 0;
      margin-left: 0;
    }
    .links p {
      color: var(--orange3);
      background: transparent;
      border-radius: ${({ theme }) => theme.borderRadius};
      padding: 0.5rem;
      border: 2px solid var(--orange3);
      margin-bottom: 0.5rem;
      transition:
        background 0.2s,
        color 0.2s;
    }
    .links p:hover,
    .links p.active {
      background: var(--orange1);
      color: var(--grey7);
    }
    .links a {
      color: var(--orange3);
      background: transparent;
      border-radius: ${({ theme }) => theme.borderRadius};
      padding: 0.5rem 1rem;
      border: 2px solid var(--orange3);
      margin-bottom: 0.5rem;
      transition:
        background 0.2s,
        color 0.2s;
      min-width: 150px;
      height: 2.5rem;
      display: flex;
      /* align-items: center; */
      justify-content: flex-start;
      white-space: nowrap;
      overflow: hidden;
      /* text-overflow: ellipsis; */
      font-size: 0.95rem;
      font-weight: 600;
      text-align: center;
    }
  }
`;

export const BottomLeftUserProfile = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
  border: 2px solid red;
  a {
    color: ${({ theme }) => theme.colors.grey1};
    margin-block: ${({ theme }) => theme.spacing.xxs};
    transition: color 0.3s ease-in-out;
  }
  a:hover {
    color: ${({ theme }) => theme.colors.orange2};
    transform: scale(1.05);
  }
  .menuCategory {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    /* background: linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.grey6},
      ${({ theme }) => theme.colors.grey4}
    ); */
    background-color: ${({ theme }) => theme.colors.grey5};
    padding: ${({ theme }) => theme.spacing.s};
    border-radius: 8px;
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: ${({ theme }) => theme.colors.grey4};
      transform: scale(1.05);
    }
  }
  .menuCategory h4 {
    color: ${({ theme }) => theme.colors.grey1};
    font-size: ${({ theme }) => theme.spacing.m};
  }
`;

export const EachDetail = styled.div`
  /* border: 1px solid blue; */
  p {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grey7};
    text-transform: capitalize;
  }
  span {
    font-style: italic;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey4};
  }
`;

export const IFrameContainer = styled.div`
  iframe {
    height: 625px;
    min-width: 100%;
    /* border: 1px solid red; */
  }
`;
